// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';
import {
  Button,
  Card,
  CardBody,
} from 'reactstrap';
import {
  CommonDialog,
  SectionHeader,
} from '@vroskus/library-components';

// Types
import type {
  $UnauthenticateAction,
} from '../../../../redux/modules/auth/actions';
import type {
  $SetActiveRegattaIdAction,
} from '../../../../redux/modules/main/actions';

export type $OwnProps = $Translate & {
  id: string;
};

export type $StateProps = Record<string, never>;

export type $DispatchProps = {
  setActiveRegattaId: $SetActiveRegattaIdAction;
  unauthenticate: $UnauthenticateAction;
};

type $Props = $DispatchProps & $OwnProps & $StateProps;

const ProfileHeaderSectionView = function ({
  id,
  setActiveRegattaId,
  t,
  unauthenticate,
}: $Props) {
  return (
    <Card id={id}>
      <SectionHeader
        iconClass={'icon-user'}
        rightButtons={(
          <CommonDialog
            content={(
              <CardBody>
                {t('Your session will be closed')}
              </CardBody>
            )}
            id={'logout-dialog'}
            labelCloseButton={t('Close')}
            labelConfirmButton={t('Confirm')}
            onAction={async () => {
              await setActiveRegattaId({
                RegattaId: null,
              });

              await unauthenticate();
            }}
            title={t('Warning')}
          >
            <Button
              color={'danger'}
              id={'logout-button'}
              outline
              size={'sm'}
            >
              {t('Logout')}
            </Button>
          </CommonDialog>
        )}
        title={t('Profile')}
      />
    </Card>
  );
};

export default ProfileHeaderSectionView;
